import { useRef, useState, useEffect } from "react";
import { useSocial } from "../../../hooks/useSocial";
import { rootUrl } from "../../../App";

import "./DraggableSocials.css";

const socialIcon =
  process.env.PUBLIC_URL +
  "/Assets/Images/Icons/DraggableHomeIcon/social-icon.svg";

const DraggableSocials = () => {
  const { socials } = useSocial();
  const dragRef = useRef(null);
  // const [position, setPosition] = useState({
  //   x: window.innerWidth - 60 - 13,
  //   y: window.innerHeight * 0.85,
  // });

  const [position, setPosition] = useState(() => {
    const isWebScreen = window.innerWidth >= 769;

    return {
      x: isWebScreen
        ? window.innerWidth * 0.67 - 60 - 13 // left: 33dvw
        : window.innerWidth - 45 - 13, // right: 13px
      y: isWebScreen
        ? window.innerHeight * 0.75
        : (window.innerHeight * 1) - 200,
    };
  });

  // { x: window.innerWidth * 0.33 - 45 - 13, y: 0 }

  const [visible, setVisible] = useState(false);

  const [isDragging, setIsDragging] = useState(false);
  const [showImages, setShowImages] = useState(false);
  const [hideImages, setHideImages] = useState(false);

  const margin = 13;
  const imageSize = 45;

  useEffect(() => {
    let animationFrame;

    const handleMove = (clientX, clientY) => {
      const el = dragRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();

      const newX = Math.min(
        Math.max(clientX - el.offsetX, margin),
        window.innerWidth - rect.width - margin
      );
      const newY = Math.min(
        Math.max(clientY - el.offsetY, margin),
        window.innerHeight - rect.height - margin
      );

      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(() => {
        setPosition({ x: newX, y: newY });
      });
    };

    // const handleMove = (clientX, clientY) => {
    //   const el = dragRef.current;
    //   if (!el) return;

    //   const rect = el.getBoundingClientRect();
    //   const iconWidth = rect.width;
    //   const iconHeight = rect.height;

    //   const isWebScreen = window.innerWidth >= 769;
    //   const margin = 13;

    //   let minX, maxX;

    //   if (isWebScreen) {
    //     minX = window.innerWidth * 0.33;
    //     maxX = window.innerWidth * 0.66 - iconWidth - margin;
    //   } else {
    //     minX = margin;
    //     maxX = window.innerWidth - iconWidth - margin;
    //   }

    //   const minY = margin;
    //   const maxY = window.innerHeight - iconHeight - margin;

    //   const newX = Math.min(Math.max(clientX - el.offsetX, minX), maxX);
    //   const newY = Math.min(Math.max(clientY - el.offsetY, minY), maxY);

    //   cancelAnimationFrame(animationFrame);
    //   animationFrame = requestAnimationFrame(() => {
    //     setPosition({ x: newX, y: newY });
    //   });
    // };

    const handleMouseMove = (e) => {
      if (!dragRef.current?.dragging) return;
      const clientX = e.clientX ?? e.touches?.[0]?.clientX;
      const clientY = e.clientY ?? e.touches?.[0]?.clientY;
      handleMove(clientX, clientY);
    };

    const stopDrag = () => {
      setIsDragging(false);
      if (dragRef.current) dragRef.current.dragging = false;
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", stopDrag);
    window.addEventListener("touchmove", handleMouseMove, { passive: false });
    window.addEventListener("touchend", stopDrag);

    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", stopDrag);
      window.removeEventListener("touchmove", handleMouseMove);
      window.removeEventListener("touchend", stopDrag);
    };
  }, []);

  const startDrag = (e) => {
    e.preventDefault();
    setIsDragging(true);

    const clientX = e.clientX ?? e.touches?.[0]?.clientX;
    const clientY = e.clientY ?? e.touches?.[0]?.clientY;

    const rect = dragRef.current.getBoundingClientRect();
    dragRef.current.dragging = true;
    dragRef.current.offsetX = clientX - rect.left;
    dragRef.current.offsetY = clientY - rect.top;
  };

  const handleClick = () => {
    if (isDragging) return;

    if (showImages) {
      setHideImages(true); // trigger floatDown
      // Wait until animation ends (300ms), then hide
      setTimeout(() => {
        setShowImages(false);
        setHideImages(false);
      }, 300);
    } else {
      setShowImages(true); // render div
      setHideImages(false); // trigger floatUp
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 600);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      ref={dragRef}
      onMouseDown={startDrag}
      onTouchStart={startDrag}
      className={`draggable-wrapper ${visible ? "slide-in" : ""}`}
      style={{
        position: "fixed",
        top: `${position.y}px`,
        left: `${position.x}px`,
        width: `${imageSize}px`,
        height: `${imageSize}px`,
        zIndex: 9999,
        cursor: "grab",
        touchAction: "none",
        userSelect: "none",
        transition: isDragging ? "none" : "top 0.25s ease, left 0.25s ease",
      }}
    >

      <div className="draggable-social-area">
        <div className="handle" onClick={handleClick}>
          <img
            className="draggable-social"
            src={
              showImages
                ? "/app/floating-support-down-45x45.png"
                : "/app/floating-support-45x45.png"
            }
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = socialIcon;
            }}
            alt="social-toggle"
            width="45"
            height="45"
          />
        </div>

        {(showImages || hideImages) && (
          <div className="floating-images">
            {socials?.map((item, index) =>
              item?.floating === true ? (
                <a
                  key={item?.id}
                  className="pointer d-flex justify-content-center align-items-center"
                  href={item?.social_prefix_id?.prefix + item?.resource}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={rootUrl + item?.social_prefix_id?.logo}
                    className={`floating-image ${hideImages ? "float-down" : "float-up"}`}
                    style={{ animationDelay: `${index * 0.3}s` }}
                    alt={`social${index}`}
                    width="30"
                    height="30"
                  />
                </a>
              ) : null
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DraggableSocials;
